define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var tcManager = require('managers/tc.manager.instance');

    module.exports = BaseReplacerView.extend({
        className: 'tc-container',

        render: function() {
            this.$el.html(this.tmpl('common.loader'));
            tcManager.fetch().done(function(terms) {
               this.$el.html(terms && terms.content || '');
            }.bind(this));

            return this;
        }
    }, {
        nameOfReplacers: [
            'TERMS_CONDITIONS'
        ]
    });
});
